import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { s3 } from 'app/utils';
import { connect } from 'react-redux';
import {
  updateCommunity,
  createCommunity,
  deleteCommunity,
} from 'modules/community/community.actions';
import SelectField from 'modules/form/selectField.component';
import CreatableMulti from 'modules/form/createSelectField.component';
import AsyncAdminField from 'modules/form/asyncAdminField.component';
import ReduxFormImageUpload from 'modules/styled/form/reduxformimageupload.component';
import ReduxFormField from 'modules/styled/form/reduxformfield.component';
import { ReduxFormTextArea } from 'modules/styled/form/textarea';

import Checkbox from 'modules/styled/form/checkbox';
import { Field, reduxForm } from 'redux-form';
import { Form, Button } from 'modules/styled/web';
import { Image, LinkFont, SecondaryText, Title, Row, View, Box } from 'modules/styled';
import { required } from 'modules/form/validators';
import { colors } from 'styles';

class CommunityAdminForm extends Component {
  static propTypes = {
    actions: PropTypes.object,
    handleSubmit: PropTypes.func,
    isUpdate: PropTypes.bool,
    initialValues: PropTypes.object,
    close: PropTypes.func,
    history: PropTypes.object,
  };

  deleteCommunity = async (e) => {
    e.preventDefault();
    const { initialValues, close } = this.props;
    if (
      // eslint-disable-next-line
      window.confirm(
        `Are you sure you want to delete this community: ${initialValues.name}?`
      )
    ) {
      const success = await this.props.actions.deleteCommunity(initialValues);
      if (success && close) close();
    }
  };

  submit = async (values) => {
    const { history } = this.props;
    try {
      const community = { ...values };
      if (community.image && community.image.preview && community.image.fileName) {
        const imageUrl = await s3.uploadFile(
          community.image.preview,
          community.image.fileType
        );
        community.image = imageUrl;
      }
      const { isUpdate } = this.props;
      if (isUpdate) {
        this.props.actions.updateCommunity(community);
      } else {
        await this.props.actions.createCommunity(community);
        history.push(`/${community.slug}/new`);
      }
    } catch (err) {
      // TODO error handling
    }
  };

  render() {
    const { handleSubmit, initialValues } = this.props;

    const customFields = initialValues.customParams
      ? [
          {
            name: 'customParams.auth.points',
            label: 'REQUIRED FOR POSTING: Added Points of Interest',
            component: ReduxFormField,
            type: 'number',
          },
          {
            name: 'customParams.auth.tokens',
            label: 'REQUIRED FOR POSTING: FOAM token balance',
            component: ReduxFormField,
            type: 'number',
          },
        ]
      : [];

    const FORM_FIELDS = [
      {
        name: 'image',
        component: ReduxFormImageUpload,
        placeholder: '/img/blueR.png',
        imageComponent: (
          <Image
            sx={{ mt: 1, bg: 'blue', p: 2, width: 10, height: 10, borderRadius: '50%' }}
          />
        ),
        type: 'file-upload',
        label: 'Community Image',
        validate: [],
      },
      {
        name: 'name',
        label: 'Name',
        component: ReduxFormField,
        type: 'text',
        validate: [required],
      },
      // {
      //   name: 'private',
      //   label: 'Private',
      //   component: Checkbox,
      //   type: 'checkbox'
      // },
      {
        name: 'slug',
        label: (
          <View>
            <LinkFont sx={{ color: 'black' }}>
              Slug (cannot be changed in the future)
            </LinkFont>
            <SecondaryText>
              Determines the url of the community, ex: relevant.community/{'<slug>'}
            </SecondaryText>
          </View>
        ),
        placeholder: 'slug',
        component: ReduxFormField,
        type: 'text',
        validate: [required],
      },
      {
        name: 'description',
        component: ReduxFormTextArea,
        type: 'text',
        label: 'Description',
        validate: [required],
      },
      {
        name: 'topics',
        component: CreatableMulti,
        type: 'text',
        label: 'Tags',
        validate: [],
      },
      {
        name: 'sectionTitle',
        text: 'Admins & Moderators',
      },
      {
        name: 'superAdmins',
        component: AsyncAdminField,
        type: 'text',
        label: (
          <View>
            <LinkFont sx={{ color: 'black' }}>Admins</LinkFont>
            <SecondaryText>
              Users with admin priveleges (ability to edit community parameters and add or
              remove moderators)
            </SecondaryText>
          </View>
        ),
        validate: [],
      },
      {
        name: 'admins',
        component: AsyncAdminField,
        type: 'text',
        label: (
          <View>
            <LinkFont sx={{ color: 'black' }}>Moderators</LinkFont>
            <SecondaryText>
              Users that will have high reputation by default (but not necessarily admin
              priveleges)',
            </SecondaryText>
          </View>
        ),
        validate: [],
      },
      {
        name: 'sectionTitle',
        text: 'Community Settings',
      },
      {
        name: 'defaultPost',
        label: 'Default Post Type',
        component: SelectField,
        // input: { value: [] },
        // value: 'link',
        options: ['link', 'text'],
      },
      ...customFields,
      {
        name: 'betEnabled',
        label: 'Enable Betting',
        component: Checkbox,
        type: 'checkbox',
      },
      {
        name: 'allowImages',
        label: 'Allow Images - users are allowed to post image posts',
        component: Checkbox,
        type: 'checkbox',
      },
      {
        name: 'hidden',
        label: 'Unlisted (anyone with link can still see and join the community)',
        component: Checkbox,
        type: 'checkbox',
      },
    ];
    return (
      <View sx={{ mx: 4, mb: 8 * 8 }}>
        <Form
          onSubmit={handleSubmit(this.submit)}
          fdirection="column"
          key="community-admin-form"
        >
          {FORM_FIELDS.map((field, index) => {
            if (field.name === 'sectionTitle')
              return (
                <Box sx={{ mt: 4 }} key={field.text + index}>
                  <Title>{field.text}</Title>
                </Box>
              );
            return <Field {...field} key={index} />;
          })}
          <Row sx={{ justifyContent: 'flex-end', mt: 6 }}>
            {initialValues._id ? (
              <Button
                type="button"
                sx={{ ml: 2, bg: 'red' }}
                onClick={this.deleteCommunity}
              >
                Delete
              </Button>
            ) : null}
            <Button sx={{ ml: 2 }} type="submit">
              Submit
            </Button>
          </Row>
        </Form>
      </View>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { close, history } = ownProps;
  let slug = ownProps?.match?.params?.slug || state.auth.community;
  if (ownProps?.match?.path === '/admin/community/new') slug = null;
  if (ownProps?.match?.path === '/communities/new') slug = null;
  const community = state.community?.communities?.[slug] || {};
  const isUpdate = !!Object.keys(community).length;
  const admins = community?.admins?.map((m) => m.embeddedUser.handle) || [];
  const superAdmins = community?.superAdmins?.map((m) => m.embeddedUser.handle) || [];

  const initialValues = { ...community, admins, superAdmins };

  return {
    routing: state.routing,
    community: state.community,
    isUpdate,
    initialValues,
    enableReinitialize: true,
    close,
    history,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      updateCommunity,
      createCommunity,
      deleteCommunity,
    },
    dispatch
  ),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    reduxForm({
      form: 'communityAdmin',
    })(CommunityAdminForm)
  )
);
